'use client';

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LocaleLink } from '@/components/locale-link';
import type { Dispatch, SetStateAction } from 'react';
import type { TFunction } from 'i18next';

interface ProFeatureDialogProps {
  showProDialog: boolean;
  setShowProDialog: Dispatch<SetStateAction<boolean>>;
  proDialogFeature: 'export' | 'columns' | 'enrich';
  t: TFunction<'translation', undefined>;
}

export function ProFeatureDialog({
  showProDialog,
  setShowProDialog,
  proDialogFeature,
  t,
}: ProFeatureDialogProps) {
  return (
<Dialog open={showProDialog} onOpenChange={setShowProDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>
              {/* Columns are free for any logged-in user — the lock only fires
                  for guests, so that prompt asks them to create an account. */}
              {proDialogFeature === 'columns'
                ? t('search.accountRequired.title', 'Konto erforderlich')
                : t('search.proFeature.title', 'Pro-Funktion')}
            </DialogTitle>
            <DialogDescription>
              {proDialogFeature === 'columns'
                ? t(
                    'search.accountRequired.descriptionColumns',
                    'Erstellen Sie ein kostenloses Konto, um die angezeigten Spalten anzupassen.',
                  )
                : proDialogFeature === 'enrich'
                  ? t(
                      'search.proFeature.descriptionEnrich',
                      'Die Datenanreicherung ist nur für Pro-Nutzer verfügbar. Mit einem Pro-Konto können Sie Websites und Mitarbeiterzahlen anreichern.',
                    )
                  : t(
                      'search.proFeature.description',
                      'Der Excel-Export ist nur für Pro-Nutzer verfügbar. Mit einem Pro-Konto können Sie Suchergebnisse exportieren.',
                    )}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="outline"
              className="rounded-md"
              onClick={() => setShowProDialog(false)}
            >
              {t('common.buttons.close', 'Schließen')}
            </Button>
            {proDialogFeature === 'columns' ? (
              <Button
                className="rounded-md"
                onClick={() => {
                  setShowProDialog(false);
                  window.location.href = `/auth/login?screen_hint=signup&returnTo=${encodeURIComponent(window.location.pathname)}`;
                }}
              >
                {t('search.accountRequired.cta', 'Konto erstellen')}
              </Button>
            ) : (
              <Button asChild className="rounded-md">
                <LocaleLink href="/plans" onClick={() => setShowProDialog(false)}>
                  {t('search.proFeature.cta', 'Pläne ansehen')}
                </LocaleLink>
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
}
